import React from "react";

export default function VideoModal({ videoId, close }) {
  return (
    <div className="modal-overlay visible active" onClick={() => close()}>
      <iframe width="1200" height="675" src={`https://www.youtube.com/embed/${videoId}`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  );
}
